import React from 'react';
import { motion } from 'framer-motion';

const TermsOfService = () => {
  const lastUpdated = "October 24, 2023";

  return (
    <div className="py-20 bg-slate-50 min-h-screen">
      <div className="container px-4 mx-auto max-w-4xl">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white p-8 md:p-12 rounded-3xl shadow-soft border border-slate-100"
        >
          <h1 className="text-4xl font-bold text-primary mb-2">Terms of Service</h1>
          <p className="text-slate-500 mb-8 border-b pb-8">Effective Date: {lastUpdated}</p>

          <div className="prose prose-slate max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-primary mb-4">1. Agreement to Terms</h2>
              <p className="text-slate-600 leading-relaxed">
                By accessing or using Review Guru, you agree to be bound by these Terms of Service. If you disagree with any part of the terms, you may not access the service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary mb-4">2. Use of Service</h2>
              <div className="space-y-4 text-slate-600">
                <p>You agree to use the service only for lawful purposes and in accordance with these Terms.</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>You must provide accurate information when creating an account.</li>
                  <li>You are responsible for maintaining the confidentiality of your account.</li>
                  <li>You must not use the service to send spam or unsolicited messages that violate anti-spam laws.</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary mb-4">3. Subscription and Billing</h2>
              <p className="text-slate-600 leading-relaxed">
                We offer a 14-day free trial. After the trial period, continued use requires a paid subscription. All fees are non-refundable unless required by law. We reserve the right to change our pricing upon 30 days' notice.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary mb-4">4. Intellectual Property</h2>
              <p className="text-slate-600 leading-relaxed">
                The Service and its original content, features, and functionality are and will remain the exclusive property of Review Guru and its licensors. Our trademarks and trade dress may not be used in connection with any product or service without our prior written consent.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary mb-4">5. Limitation of Liability</h2>
              <p className="text-slate-600 leading-relaxed">
                In no event shall Review Guru, nor its directors, employees, or partners, be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, or other intangible losses.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary mb-4">6. Termination</h2>
              <p className="text-slate-600 leading-relaxed">
                We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
              </p>
            </section>

            <section className="bg-secondary/10 p-6 rounded-2xl border border-secondary/20">
              <h2 className="text-2xl font-bold text-primary mb-4">7. Governing Law</h2>
              <p className="text-slate-600">
                These Terms shall be governed and construed in accordance with the laws of Victoria, Australia, without regard to its conflict of law provisions.
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default TermsOfService;